import { Action, createReducer, on } from "@ngrx/store";
import * as fromSelectedStudentsActions from "../actions/selected-students.action";
import { AssignSelectedCourses } from "#models/assign-selected-courses.interface";

export interface AssignListState {
    selectedCourses: AssignSelectedCourses | null;
    assignWorking: boolean;
}

export const initialState: AssignListState = {
    selectedCourses: null,
    assignWorking: false,
};
const assignListReducer = createReducer(
    initialState,
    on(fromSelectedStudentsActions.assign, (state, { payload }) => {
        return {
            ...state,
            assignWorking: true,
        };
    }),
    on(fromSelectedStudentsActions.assignSuccess, (state, { payload }) => {
        return {
            ...state,
            assignWorking: false,
        };
    }),
    on(
        fromSelectedStudentsActions.updateSelectedStudents,
        (state, { payload }) => {
            return {
                ...state,
                selectedCourses: payload,
            };
        }
    )
);
export function reducer(state: AssignListState | undefined, action: Action) {
    return assignListReducer(state, action);
}

export const getSelectedAssignStudents = (state: AssignListState) =>
    state.selectedCourses;
export const getAssignWorking = (state: AssignListState) => state.assignWorking;
